import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";

const left = (iso) => {
  const ms = new Date(iso).getTime() - Date.now();
  if (ms <= 0) return null;
  const d = Math.floor(ms / 864e5), h = Math.floor((ms % 864e5) / 36e5), m = Math.floor((ms % 36e5) / 6e4), s = Math.floor((ms % 6e4) / 1e3);
  return `${d ? `${d}d ` : ""}${h}h ${m}m ${s}s`;
};

export const Countdown = ({ round }) => {
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((x) => x + 1), 1000); return () => clearInterval(t); }, []);
  const label = round.phase === "upcoming" ? `Voting opens in ${left(round.starts_at) || "moments"}`
    : round.phase === "open" ? `Closes in ${left(round.ends_at) || "moments"}` : "Voting closed";
  const when = ["open", "upcoming"].includes(round.phase) ? "closes" : "closed";
  return (
    <p className="text-sm font-bold text-amber-200" data-testid="fanvote-countdown">
      {label} <span className="text-gray-500 font-normal">· {when} {new Date(round.ends_at).toLocaleString()}</span>
    </p>
  );
};

export const Leaderboard = ({ entries, roundId }) => (
  <div className="divide-y divide-white/5" data-testid="fanvote-leaderboard">
    {entries.length === 0 && <p className="text-sm text-gray-500 py-6" data-testid="fanvote-leaderboard-empty">No approved songs yet.</p>}
    {entries.map((e) => (
      <div key={e.entry_id} className="py-3 flex items-center gap-3" data-testid={`fanvote-row-${e.entry_id}`}>
        <span className="w-8 text-center text-lg font-black text-purple-300">{e.is_winner ? <Trophy className="w-5 h-5 text-amber-300 inline" /> : e.rank}</span>
        <img src={e.cover_url} alt="" className="w-12 h-12 rounded-lg object-cover bg-gray-800" />
        <div className="flex-1 min-w-0">
          <Link to={`/fan-vote/entry/${e.entry_id}`} className="text-white font-bold truncate block hover:underline" data-testid={`fanvote-row-link-${e.entry_id}`}>{e.track_title}</Link>
          <p className="text-xs text-gray-400 truncate">{e.artist_name}{e.is_winner ? " · RGM Fan Choice" : ""}</p>
        </div>
        <span className="text-white font-black tabular-nums" data-testid={`fanvote-row-votes-${e.entry_id}`}>{e.votes}</span>
        <span className="text-[11px] text-gray-500">{e.votes === 1 ? "vote" : "votes"}</span>
      </div>
    ))}
  </div>
);
